import "katex/dist/katex.min.css?__remix_sideEffect__";
import React, { useEffect, useRef, useState } from 'react';


function normalizeLatex(content) {
  console.log(content);
  const normalized = content.
  replace(/\\\(([\s\S]*?)\\\)/g, (_, m) => `$ ${m} $`).
  replace(/\\\[((?:.|\n)*?)\\\]/g, (_, m) => `$$\n${m}\n$$`);
  // .replace(/(\\begin\{[^}]+\}[\s\S]+?\\end\{[^}]+\})/g, (_, block) => `\n\n$$\n${block}\n$$\n\n`);
  console.log(normalized);
  return normalized;
}

export default function KatexRender({ math }) {
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const processedContent = normalizeLatex(math);
  const renderedRef = useRef(null);

  useEffect(() => {
    const loadModules = async () => {
      try {
        const [
        { default: ReactMarkdown },
        { default: remarkMath },
        { default: rehypeKatex },
        { default: remarkGfm },
        { default: remarkBreaks }] =
        await Promise.all([
        import('react-markdown'),
        import('remark-math'),
        import('rehype-katex'),
        import('remark-gfm'),
        import('remark-breaks')]
        );

        setModules({
          ReactMarkdown,
          remarkMath,
          rehypeKatex,
          remarkGfm,
          remarkBreaks
        });
      } catch (err) {
        console.error('Failed to load markdown modules:', err);
        setError('Failed to load markdown renderer');
      } finally {
        setLoading(false);
      }
    };

    loadModules();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '1rem' }}>
        Loading markdown renderer...
      </div>);

  }

  if (error || !modules) {
    return (
      <div style={{ padding: '1rem', color: '#e53e3e' }}>
        {error || 'Failed to load markdown renderer'}
      </div>);

  }

  const { ReactMarkdown, remarkMath, rehypeKatex, remarkGfm, remarkBreaks } = modules;
  return (
    <div
      ref={renderedRef}
      className="markdown"
      style={{
        fontFamily: 'sans-serif',
        fontSize: '16px',
        lineHeight: '1.6',
        padding: '1rem'
      }}>

      <style>{`
        .markdown ul { list-style-position: inside; white-space: normal; }
        .markdown ol { list-style-position: inside; white-space: normal; }
        .markdown li { padding-left: 10px; margin-bottom: 0.5rem; line-height: 1.6; }
        .markdown ul li ul { padding-left: 20px; }
        .markdown .latex-display { display: block; margin: 1rem 0; }
        .markdown .latex-inline { display: inline; }
        .markdown li p { margin: 0; display: inline; }
        .markdown p { margin: 0.5rem 0; display: block; }
        .markdown table { border-collapse: collapse; max-width: 100%; margin-bottom: 0; margin-top: 1rem; }
        .markdown th, .markdown td { border: 1px solid #130159; padding: 8px; text-align: left; vertical-align: top; }
        .markdown th { font-weight: bold; background-color: #f2f2f2; }
        .markdown tr:last-child td { margin-bottom: 0; }
        .markdown .katex-display { text-align: left; margin: 1rem 0; }
      `}</style>
      <ReactMarkdown
        children={processedContent}
        remarkPlugins={[remarkMath, remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeKatex]} />

    </div>);

}